export default {
  'notifications.success.label': 'Succés!',
  'notifications.success.generic_message': "L'action effectuée a réussi.",
  'notifications.warning.label': 'Avertissement',
  'notifications.errors.label': 'Erreur',
  'notifications.errors.something_went_wrong':
    "Quelque chose s'est mal passé. Veuillez réessayer.",
};
